<template>
    <div>
        <div class="page">
            <div class="title">基本信息</div>
            <div class="form">
                <div class="form-item">
                    <div class="form-label">企业名称:</div>
                    <div class="form-value">{{ result.firmName || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">统一社会信用代码:</div>
                    <div class="form-value">{{ result.creditCode || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">企业法人:</div>
                    <div class="form-value">{{ result.firmHuman || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">注册时间:</div>
                    <div class="form-value">{{ result.setTime || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">注册资本(万):</div>
                    <div class="form-value">{{ result.fundMoney || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">企业人数:</div>
                    <div class="form-value">{{ result.employees || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">企业类型:</div>
                    <div class="form-value">{{ result.firmType || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">联系电话:</div>
                    <div class="form-value">{{ result.phone || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">所属行业:</div>
                    <div class="form-value">{{ result.involved || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">注册资金:</div>
                    <div class="form-value">{{ result.fundMoney || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">从业人数:</div>
                    <div class="form-value">{{ result.employees || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">报税金额(万):</div>
                    <div class="form-value">{{ result.yearTax || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">经营范围:</div>
                    <div class="form-value" :title="result.manage">{{ cutStr(result.manage,20) || "-" }}</div>
                </div>
                <div class="form-item">
                    <div class="form-label">详细地址:</div>
                    <div class="form-value" :title="result.address">{{ cutStr(result.address,20) || "-" }}</div>
                </div>

                <template v-if="result.business">
                    <div class="title" :style="{ marginTop: '54px' }">企业认证</div>
                    
                    <div class="img-list">
                        <div class="item">
                            <div class="title">上传法人认证：</div>
                            <img class="img" :src="result.business"/>
                        </div>
                    </div>
                </template>
                
                <!-- <Button type="primary" :style="{marginLeft: '10px',width: '100px'}">更改</Button> -->
            </div>
        </div>
    </div>
</template>

<script>
import { Message } from "ant-design-vue";
import { getAction } from "@/util/require.js";
export default {
    name: "",
    components: {},
    data() {
        return {
            result: {}
        };
    },
    created() {},
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            getAction("/hq/webPage/checkMyFirm").then(res => {
                if (res.success) {
                    this.result = res.result;
                } else {
                    Message.error(res.message);
                }
            });
        },
        cutStr(str, len = 10) {
            if (str) {
                if (str.length > len) {
                    return str.slice(0, len - 2) + "...";
                } else {
                    return str;
                }
            } else {
                return "";
            }
        },
    }
};
</script>

<style scoped lang="scss">
.page {
    width: 100%;
    padding: 30px 105px 0 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background: #fff;
    box-shadow: 0px 7px 24px 0px rgba(8, 124, 232, 0.15);
    border-radius: 2px;
    min-height: 800px;
}
.title {
    font-size: 34px;
    font-family: PingFang;
    font-weight: bold;
    color: #333333;
}
.form {
    padding: 0 0 30px;
    width: 100%;
    .form-item {
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        margin-top: 30px;
        line-height: 65px;
        height: 65px;
        width: 100%;
        border-bottom: 1px solid rgba(229, 229, 229, 1);
    }
    .form-label {
        font-weight: bold;
    }
    .form-value {
        color: #a9a9a9;
        font-weight: 600;
    }

    .img-list{
        display: flex;
        flex-direction: row;
        margin-top: 30px;
        .item{
            margin-left: 20px;
            .title{
                font-size: 20px;
                font-weight: 600;
                color: #333333;
            }
            .img{
                margin-top: 20px;
                max-width: 300px;
                max-height: 300px;
                border-radius: 10px;
            }
        }
    }
}
</style>
